import React, { Component } from 'react';
import { List } from  'antd';
import { pra, praTitle } from '../../utils/legalUtils';

export default class AfspPAS extends Component {
    render() {
        return (
            <div style={{ marginLeft: '10px', marginRight: '10px' }}>
                <div className='afsp-layout-title'>
                    {praTitle}
                </div>
                <List
                    itemLayout="horizontal"
                    dataSource={pra}
                    renderItem={item => (
                        <List.Item>
                            <div className='afsp-layout-pra-content'>
                                {item.content}
                            </div>
                        </List.Item>
                    )}
                >
                </List>
            </div>
        )
    }
}
